import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService, CampaignService, EventsService, SeoService, UtilService, VariablesService } from 'projects/roj/src/app/shared/services';
import { Subscription } from 'rxjs/internal/Subscription';
import { MatDialog } from '@angular/material/dialog';
import { FundraiserCardComponent } from "../../core/fundraiser-card/fundraiser-card.component";
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-fundraisers-listing',
  standalone: true,
  imports: [CommonModule, FundraiserCardComponent, NgxGlideModule, MatIconModule],
  templateUrl: './fundraisers-listing.component.html',
  styleUrls: ['./fundraisers-listing.component.scss']
})
export class FundraiserListing implements OnInit, OnDestroy {
  isMobile: any;
  fundraisersList;
  taxBenefit = false;

  subs: Subscription[] = [];

  constructor(
    private api: ApiService,
    private events: EventsService,
    private seo: SeoService,
    public util: UtilService,
    public dialog: MatDialog,
    public vars: VariablesService,
    private campaignService: CampaignService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.isMobile = this.util.isMobile() || queryParams?.isMobile;
    this.dialog.closeAll();
    this.util.scrollToTop('instant');
    this.util.addCssToGlobal('https://use.typekit.net/dfp6xcg.css');
    this.vars.mainLayoutConfig.next({
      showSecure: false,
      showHeader: false,
      showBasicHeader: false,
      animateHeader: false,
      logoNavigate: false,
      showCurrency: false,
      showMenus: false
    });

    this.getFundraisers();

    this.events.onLoadSystemEvent({
      eventName: 'pageView'
    });

    this.subs.push(this.vars.isDomainLoaded.subscribe({
      next: (res) => {
        if (res) {
          this.setSeoData();
        }
      }
    }));
  }

  getFundraisers() {
    this.campaignService.getDashboardData({ task: 'get_campaigns', count: 50 }).subscribe((val: any) => {
      if (val?.data) {
        this.taxBenefit = val?.data?.tax_benefit;
        this.fundraisersList = val?.data?.ngo_active_campaigns;
      }
    });
  }

  setSeoData() {
    const title = `${this.util.domain_details.domain_url}`;
    const desc = `${this.util.domain_details.domain_url}`;
    const keywords = `contact us,${this.util.domain_details.domain_url.toLowerCase()},ngo,foundation,nonprofit`;
    this.util.setPageTitle(title);
    const metaData = [
      { name: 'author', content: this.util.domain_details.domain_url },
      { name: 'description', content:  desc},
      { name: 'keywords', content:  keywords},
      { property: 'og:title', content: title },
      { property: 'og:site_name', content: this.vars.domainName },
      { property: 'og:url', content: this.util.domain_details.domain_url + this.util.router.url },
      { property: 'og:image', content: this.util.logoUrlDark || this.util.logoUrlLight },
      { property: 'og:description', content: desc },
    ]
    this.seo.addMetaTags(metaData);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
